  (function() {
    const autoplaySelector = 'video[autoplay], video[data-autoplay="true"], video[data-viewport-autoplay="true"]';

    function loadDeferredSources(video) {
      let shouldLoad = false;

      if (video.dataset.src && !video.src) {
        video.src = video.dataset.src;
        shouldLoad = true;
      }

      video.querySelectorAll('source[data-src]').forEach((source) => {
        if (!source.src) {
          source.src = source.dataset.src;
          shouldLoad = true;
        }
      });

      if (shouldLoad) {
        video.load();
      }
    }

    function shouldObserve(video) {
      if (!video || video.dataset.viewportObserverBound == 'true') {
        return false;
      }

      if (!video.matches(autoplaySelector)) {
        return false;
      }

      if (video.controls && video.dataset.viewportAutoplay != 'true') {
        return false;
      }

      return true;
    }

    function observeVideos(root) {
      if (!('IntersectionObserver' in window)) {
        return;
      }

      const scope = root && typeof root.querySelectorAll === 'function' ? root : document;

      const observer = window.__bleequpViewportVideoObserver || new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;

          if (entry.isIntersecting) {
            loadDeferredSources(video);
            video.muted = true;
            video.defaultMuted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, {
        rootMargin: '0px',
        threshold: 0.5
      });

      window.__bleequpViewportVideoObserver = observer;

      scope.querySelectorAll(autoplaySelector).forEach(video => {
        if (!shouldObserve(video)) {
          return;
        }

        video.dataset.viewportObserverBound = 'true';
        observer.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observeVideos(document));
    } else {
      observeVideos(document);
    }

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) {
            return;
          }

          if (node.matches && node.matches(autoplaySelector)) {
            observeVideos(node.parentNode || document);
          } else if (node.querySelectorAll) {
            observeVideos(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
